export const ORGANIZATION_USER_TOASTS = {
  INVITED: '{numEmails, plural, one {Invite} other {Invites}}  sent to {emails}',
  ACCESS_UPDATED: 'User account access updated',
  ORG_USER_ROLE_UPDATED: 'User role changed to {name}',
  ORG_USER_REMOVED: 'User removed',
};
